import { z } from 'zod';
import { create } from 'zustand';

const initAcfStore = z.object({
  afcType: z
    .union([z.literal('znglist'), z.literal('category')])
    .nullable()
    .default(null),
  toId: z.string().nullable().default(null),
  initIds: z.array(z.string()).default([]),
  selectedIds: z.array(z.string()).default([]),
  limit: z.number().default(100),
});

type AfcStore = z.infer<typeof initAcfStore>;

type AfcStoreActions = {
  reset: () => void;
};

type AfcStoreState = AfcStore & AfcStoreActions;

export const useAfcStore = create<AfcStoreState>((set, get) => ({
  ...initAcfStore.parse({}),
  reset: () => set({ ...initAcfStore.parse({}) }),
}));
